// src/pages/ContactPage.js
import React, { useState } from 'react';
import styles from '../styles/StaticPages.module.css';
import { Helmet } from 'react-helmet';


const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Contact Us | Support & Customer Service | MakeMeSongs</title>
        <meta name="description" content="Need help with your custom song? Contact our support team at MakeMeSongs by phone, email, or through our contact form. We respond to all inquiries within 24 hours." />
        <meta name="keywords" content="custom song support, music service contact, personalized song help, custom music customer service" />
        <meta property="og:title" content="Contact MakeMeSongs Customer Service" />
        <meta property="og:description" content="Reach our support team by phone, email, or contact form. We're here to help with all your custom song creation needs." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://makemesongs.com/contact" />
        <meta property="og:image" content="https://makemesongs.com/og-image.jpg" />
        <link rel="canonical" href="https://makemesongs.com/contact" />
      </Helmet>
      <h1 className={styles.pageTitle}>Contact Us</h1>
      <p className={styles.introText}>
        Have questions or need assistance? We're here to help. Fill out the form below 
        or reach out to our support team directly.
      </p>

      <div className={styles.contentWrapper}>
        <div className={styles.contactLayout}>
          <div className={styles.contactInfo}>
            <h2>We're Here to Help</h2>
            <p>
              Have questions about our custom songs or need help with your order?
              Our team is ready to assist you.
            </p>
            
            <div className={styles.contactMethods}>
              <div className={styles.contactMethod}>
                <div className={styles.contactIcon}>✉️</div>
                <div className={styles.contactDetail}>
                  <h3>Email Us</h3>
                  <span><a href="mailto:support@makemesongs.com">support@makemesongs.com</a></span>
                  <p>For customer support and general inquiries</p>
                </div>
              </div>
              
              <div className={styles.contactMethod}>
                <div className={styles.contactIcon}>📞</div>
                <div className={styles.contactDetail}>
                  <h3>Call Us</h3>
                  <span><a href="tel:7548008154">(754) 800-8154</a></span>
                  <p>Monday to Friday, 9am - 5pm EST</p>
                </div>
              </div>
              
              <div className={styles.contactMethod}>
                <div className={styles.contactIcon}>⏱️</div>
                <div className={styles.contactDetail}>
                  <h3>Response Time</h3>
                  <p>We typically respond to all inquiries within 24 hours during business days.</p>
                </div>
              </div>
            </div>
            
            <div className={styles.faqPromo}>
              <h3>Frequently Asked Questions</h3>
              <p>Find quick answers to common questions on our <a href="/faq" className={`${styles.inlineLink} ${styles.whiteLink}`}>FAQ page</a>.</p>
            </div>
          </div>
          
          <div className={styles.contactForm}>
            <h2>Send Us a Message</h2>
            
            <form 
              name="contact" 
              method="POST" 
              netlify 
              netlify-honeypot="bot-field"
              action="/thank-you"
            >
              <input type="hidden" name="form-name" value="contact" />
              <p className="hidden">
                <label>
                  Don't fill this out if you're human: 
                  <input name="bot-field" />
                </label>
              </p>

              <div className={styles.formGroup}>
                <label htmlFor="name">Your Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className={styles.formControl}
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className={styles.formControl}
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className={styles.formControl}
                />
              </div>
              
              <div className={styles.formGroup}>
                <label htmlFor="message">Your Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className={styles.formControl}
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className={styles.submitButton}
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;